import React, { PureComponent, Fragment } from 'react';
import $ from 'jquery';
import Cookies from 'js-cookie';
import Step from './step';

const prefix = 'WechatNoticeShowed_';
export default class WechatNotice extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      show: Cookies.get(prefix + window.pageProps.uid) !== 'showed',
    };
  }

  onNext = () => {
    this.setState({
      show: false,
    });
    Cookies.set(prefix + window.pageProps.uid, 'showed');
  };

  render() {
    return (
      <Fragment className="wechat-notice-popover">
        {this.state.show && (
          <Step
            desc="登录账号绑定微信号，并扫码绑定“腾讯广告线索管理”即可收到线索到达和分配的微信提醒。
                    详情可见快捷帮助 - 系统设置 - 消息提醒"
            placement="left"
            getTarget={() => {
              console.log('getTarget length is', $('.main .helper').length);
              return $('.main .helper').get(0);
            }}
            onSkip={() => {}}
            nextLabel="我知道了"
            hideSkip={true}
            // show={this.state.show}
            onNext={this.onNext}
          />
        )}
      </Fragment>
    );
  }
}
